import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { getStorageUrl, STORAGE_BUCKETS } from "@/utils/storageUtils";

const CharacterProfiles = () => {
  // Helper function to get proper image URLs
  const getCharacterImageUrl = (imagePath: string) => {
    if (!imagePath) return "";
    if (imagePath.startsWith("http")) return imagePath;
    return getStorageUrl(STORAGE_BUCKETS.CHARACTER_IMAGES, imagePath);
  };

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teedee-blue mb-4">
            Meet Our Heroes
          </h2>
          <p className="text-xl text-gray-600">
            Two best friends on a mission to learn and share!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Bobo */}
          <Card className="overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 bg-white/80 backdrop-blur-sm border-2 border-bobo-green/30">
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <div className="w-32 h-32 bg-bobo-green/20 rounded-full flex items-center justify-center mx-auto mb-4 overflow-hidden">
                  <img
                    src="/img/characters/bobo.png"
                    alt="Bobo the turtle character"
                    className="w-28 h-28 object-contain rounded-full"
                  />
                </div>
                <h3 className="text-3xl font-bold text-bobo-green mb-2">
                  Bobo the Turtle
                </h3>
                <p className="text-lg text-gray-600">
                  The Wise & Caring Leader
                </p>
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-bobo-green mb-2">
                    Personality:
                  </h4>
                  <p className="text-gray-600">
                    Bobo is thoughtful, patient, and always ready to help his
                    friends. He loves to explore and learn about the world
                    around him, especially the beautiful nature of the Cayman
                    Islands.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-bobo-green mb-2">
                    Fun Facts:
                  </h4>
                  <ul className="text-gray-600 space-y-1">
                    <li>
                      • Favorite activity: Swimming in crystal clear waters
                    </li>
                    <li>• Loves: Stew Conch and local Cayman cuisine</li>
                    <li>
                      • Special talent: Remembering important life lessons
                    </li>
                    <li>• Dream: To visit every beach in the Cayman Islands</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-bobo-green mb-2">
                    Teaches Children:
                  </h4>
                  <p className="text-gray-600">
                    Patience, environmental awareness, and the importance of
                    taking time to appreciate the beauty in everyday moments.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Teedee */}
          <Card className="overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 bg-white/80 backdrop-blur-sm border-2 border-teedee-blue/30">
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <div className="w-32 h-32 bg-teedee-blue/20 rounded-full flex items-center justify-center mx-auto mb-4 overflow-hidden">
                  <img
                    src="/img/characters/teedee.png"
                    alt="Teedee the iguana character"
                    className="w-28 h-28 object-contain rounded-full"
                  />
                </div>
                <h3 className="text-3xl font-bold text-teedee-blue mb-2">
                  Teedee the Iguana
                </h3>
                <p className="text-lg text-gray-600">
                  The Energetic & Curious Explorer
                </p>
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-teedee-blue mb-2">
                    Personality:
                  </h4>
                  <p className="text-gray-600">
                    Teedee is energetic, curious, and always eager to try new
                    things. His enthusiasm is contagious, and he loves making
                    new friends wherever he goes in the Cayman Islands.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-teedee-blue mb-2">
                    Fun Facts:
                  </h4>
                  <ul className="text-gray-600 space-y-1">
                    <li>
                      • Favorite activity: Dancing to Cayman traditional music
                    </li>
                    <li>• Loves: Exploring coral reefs and marine life</li>
                    <li>
                      • Special talent: Making everyone laugh with his jokes
                    </li>
                    <li>• Dream: To learn every traditional Cayman dance</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-teedee-blue mb-2">
                    Teaches Children:
                  </h4>
                  <p className="text-gray-600">
                    Curiosity, courage to try new things, and the joy of
                    celebrating cultural traditions and diversity.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <Button
            asChild
            size="lg"
            className="bg-teedee-blue hover:bg-teedee-blue/90 text-lg px-8 py-4 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
          >
            <a href="/characters">Meet All Characters</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CharacterProfiles;
